function favAjaxLink(link) {
    var favLink = link;
    $.ajax({
        type: 'GET'
        ,url: link.attr("href")
        //     ,beforeSend: function() {}
        ,success: function(ret) {
            if(ret.status) {
                var identClass = ".fav-item-"+ret.identClass;

                if(typeof ret.content !== undefined) {
                    $('body').append(ret.content);
                    $('#oblibene').modal();
                    $('#oblibene').on('hidden.bs.modal', function (e) {
                        $(this).remove();
                    });
                }
                if(typeof ret.href !== 'undefined') {
                    $(identClass+".fav-link-change").attr('href',ret.href);
                }
                if(typeof ret.addclass !== 'undefined') {
                    $(identClass).addClass(ret.addclass);
                }
                if(typeof ret.removeclass !== 'undefined') {
                    $(identClass).removeClass(ret.removeclass);
                }
                if(typeof ret.icon !== 'undefined') {
                    if(typeof ret.icon.iconClass !== 'undefined')$(identClass+' .fav-icon').removeClass().addClass('fav-icon').addClass(ret.icon.iconClass);
                }
                if(typeof ret.text !== 'undefined') {
                    $(identClass+" .fav-text-change").html(ret.text);
                }
                if(typeof ret.favCount !== 'undefined') {
                    $('header .fav-count').html('('+ret.favCount+')');
                }
                // else {
                //     $('header .fav-count').html('');
                // }
                if(typeof ret.gaevent !== 'undefined') {
                    ga('p.send', "event", {
                        eventCategory: ret.gaevent.category,
                        eventAction: ret.gaevent.action,
                        eventValue: ret.gaevent.value
                    });
                }
            }
        }
        //     ,complete: function() {}
    });
}

$('body').on('click','a.favourite,a.btn-delete-fav',function(){
    favAjaxLink($(this));
    return false;
});